import React, { useEffect } from "react";
import LOGO from "../../assets/images/logos/logo.png";
import { forwardRef } from "react";

const PolicyWording = forwardRef(({ clauses }, ref) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      // behavior: "smooth",
    });
  }, []);

  return (
    <div className='mt-3 pb-2' ref={ref}>
      <div className='d-flex flex-column justify-content-center align-items-center'>
        <img src={LOGO} alt='logo' width={100} />
        <h4
          className='text-uppercase text-primary fw-bold'
          style={{ fontSize: "30px", color: "#2e3192" }}
        >
          PRUDENT CHOICE MICROINSURANCE
        </h4>
      </div>

      <div
        className='d-flex justify-content-center align-items-center h-50 w-100'
        style={{ backgroundColor: "#727CF5" }}
      >
        <h5
          className='text-uppercase text-white fw-bold font-22'
          style={{ fontSize: "35px" }}
        >
          POLICY CLAUSES
        </h5>
      </div>

      {clauses?.map((item, i) => (
        <div className='my-2' key={i}>
          <h5 className='text-uppercase'>{item?.clause_name}</h5>
          <div
            dangerouslySetInnerHTML={{
              __html: item?.clause_desc,
            }}
          />
        </div>
      ))}
    </div>
  );
});

export default PolicyWording;
